import React from 'react';

const DownloadPDF = () => {
  const pdfPath = '/pdf/a5_order_form.pdf';

  return (
    <div className="min-h-dvh flex flex-col items-center bg-candy-background px-4 py-10">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-hobo text-candy-text mb-6 text-center">
        View or Download PDF
      </h1>

      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-md p-4 sm:p-6 text-center border border-candy-border">
        <div className="w-full">
          <embed
            src={pdfPath}
            type="application/pdf"
            width="100%"
            className="rounded border h-[500px] sm:h-[800px] md:h-[1000px]"
          />
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
          <a
            href={pdfPath}
            download="a5_order_form.pdf"
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded"
          >
            Download original PDF
          </a>
          <a
            href={pdfPath}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded"
          >
            View in New Tab
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadPDF;
